import { xCheck } from './xCheck';
/**
 * Computes the maximal value of an array of values
 *
 * @param array - array of numbers
 * @param options - options
 */
export function xMaxValue(array, options = {}) {
    xCheck(array);
    const { fromIndex = 0, toIndex = array.length - 1 } = options;
    let maxValue = array[fromIndex];
    for (let i = fromIndex + 1; i <= toIndex; i++) {
        if (array[i] > maxValue) {
            maxValue = array[i];
        }
    }
    return maxValue;
}
//# sourceMappingURL=xMaxValue.js.map